<template>
  <v-container>
    <h3 class="my-2">Groups</h3>
    <v-select v-model="filters.type" label="Group Type" :items="options.type" />
    <v-data-table
      :headers="headers"
      :items="groups"
      :items-per-page="100"
      :loading="$apollo.loading"
      dense
      class="mt-2 elevation-2"
    />
  </v-container>
</template>

<script>
import { GROUPS_NODE_REPORT_QUERY } from "@/constants/graphql/groups/groups";
import { extractNodes } from "@/lib/array";

export default {
  name: "GroupReport",
  components: {},
  data() {
    return {
      options: {
        type: ["GENERAL", "PRIMARY", "ACCOUNTABILITY", "SUBURB", "GYM"],
      },
      filters: {
        type: null,
      },
      headers: [
        { text: "Title", value: "title" },
        { text: "Members", value: "memberCount" },
        { text: "Posts Yesterday", value: "totalPostCountYesterday" },
        { text: "Posts for Week", value: "totalPostCountWeek" },
        { text: "Total Posts", value: "totalPostCountTotal" },
        { text: "Comments Yesterday", value: "totalCommentCountYesterday" },
        { text: "Comments for Week", value: "totalCommentCountWeek" },
        { text: "Total Comments", value: "totalCommentCountTotal" },
        { text: "Likes Yesterday", value: "totalLikeCountYesterday" },
        { text: "Likes for Week", value: "totalLikeCountWeek" },
        { text: "Total Likes", value: "totalLikeCountTotal" },
      ],
    };
  },
  apollo: {
    groups: {
      query: GROUPS_NODE_REPORT_QUERY,
      variables() {
        return {
          type: this.filters.type,
          afterDateYesterday: this.$moment()
            .subtract(1, "days")
            .format("YYYY-MM-DD"),
          afterDateWeek: this.$moment()
            .subtract(7, "days")
            .format("YYYY-MM-DD"),
          afterDateTotal: this.$moment()
            .subtract(10, "years")
            .format("YYYY-MM-DD"),
        };
      },
      update(data) {
        return extractNodes(data.groups.edges);
      },
      skip() {
        return !this.filters.type;
      },
    },
  },
};
</script>
